export const NOTIFICATION_MODES = {
  ALL: 'ALL',
  DIRECT_ONLY: 'DIRECT_ONLY'
}

export const ADMIN_NOTIFICATION_MODES = NOTIFICATION_MODES

const normalizeNotificationMode = (mode) =>
  mode === NOTIFICATION_MODES.DIRECT_ONLY
    ? NOTIFICATION_MODES.DIRECT_ONLY
    : NOTIFICATION_MODES.ALL

export const getAdminNotificationMode = (data) =>
  normalizeNotificationMode(data?.notificationPreferences?.adminMode)

export const getNotificationMode = (data, user = data) => {
  const preferences = data?.notificationPreferences
  const roleMode =
    user?.role === 'GERENCIA'
      ? preferences?.managementMode
      : preferences?.adminMode

  return normalizeNotificationMode(preferences?.mode || roleMode)
}

export const canConfigureNotificationPreferences = (user) =>
  ['ADMINISTRADOR', 'GERENCIA'].includes(user?.role)

export const isDirectOnlyAdministrator = (user, adminMode) =>
  user?.role === 'ADMINISTRADOR' &&
  adminMode === ADMIN_NOTIFICATION_MODES.DIRECT_ONLY

export const isDirectOnlyManagement = (user, mode) =>
  user?.role === 'GERENCIA' && mode === NOTIFICATION_MODES.DIRECT_ONLY
